if (!customElements.get('igo-hat-preview')) {
  customElements.define('igo-hat-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.assets = JSON.parse(this.querySelector('[data-preview-assets]').textContent);
      this.stage = this.querySelector('[data-preview-stage]');
      this.caption = this.querySelector('[data-preview-caption]');
      this.options = JSON.parse(this.querySelector('[data-preview-options]').textContent);
      this.draw();
      document.addEventListener('variant:change', event => {
        if (event.target.getAttribute?.('id') !== this.dataset.formId) return;
        const options = event.detail.variant?.options;
        if (options) { this.options = options; this.draw(); }
        else { this.clear(); }
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
    clear() {
      this.options = null;
      this.stage.replaceChildren();
      this.dataset.ready = 'false';
      this.caption.textContent = this.dataset.unavailable;
    }
    draw() {
      try {
        this.stage.innerHTML = IgoHatComposer.render(this.options, this.assets, this.id + '-art');
        this.caption.textContent = IgoHatComposer.resolve(this.options, this.assets).label;
        this.dataset.ready = 'true';
      } catch (error) {
        this.clear();
      }
    }
  });
}
